import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Divider, Alert } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API_BASE = process.env.NODE_ENV === 'production' 
  ? ''  // 生产环境使用相对路径，Nginx会代理
  : 'http://localhost:3002';  // 开发环境

const Settings = () => {
  const [passwordForm] = Form.useForm();
  const [usernameForm] = Form.useForm();
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);

  // 修改密码
  const handleChangePassword = async (values) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_BASE}/api/auth/admin/change-password`,
        {
          current_password: values.current_password,
          new_password: values.new_password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        message.success(response.data.message);
        passwordForm.resetFields();
        // 密码修改成功后退出登录，让用户重新登录
        setTimeout(() => {
          logout();
          window.location.href = '/login';
        }, 2000);
      }
    } catch (error) {
      const msg = error.response?.data?.message || '修改密码失败';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  // 修改用户名
  const handleChangeUsername = async (values) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_BASE}/api/auth/admin/change-username`,
        {
          new_username: values.new_username,
          password: values.password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        message.success(response.data.message);
        usernameForm.resetFields();
        // 用户名修改成功后退出登录
        setTimeout(() => {
          logout();
          window.location.href = '/login';
        }, 2000);
      }
    } catch (error) {
      const msg = error.response?.data?.message || '修改用户名失败';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>账户设置</h2>
      <p style={{ color: '#666', marginBottom: 24 }}>
        当前登录用户: <strong>{user?.username}</strong>
      </p>

      <Alert
        message="安全提示"
        description="修改用户名或密码后，系统会自动退出登录，请使用新凭据重新登录。"
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Card title="修改用户名" style={{ marginBottom: 24 }}>
        <Form
          form={usernameForm}
          layout="vertical"
          onFinish={handleChangeUsername}
        >
          <Form.Item
            label="新用户名"
            name="new_username"
            rules={[
              { required: true, message: '请输入新用户名' },
              { min: 3, message: '用户名至少3个字符' },
              { max: 20, message: '用户名最多20个字符' },
              {
                pattern: /^[a-zA-Z0-9_]+$/,
                message: '用户名只能包含字母、数字和下划线',
              },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="请输入新用户名"
              maxLength={20}
            />
          </Form.Item>

          <Form.Item
            label="当前密码"
            name="password"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请输入当前密码以确认身份"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              修改用户名
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="修改密码">
        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={handleChangePassword}
        >
          <Form.Item
            label="当前密码"
            name="current_password"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请输入当前密码"
            />
          </Form.Item>

          <Form.Item
            label="新密码"
            name="new_password"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 8, message: '密码长度至少8位' },
              {
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
                message: '密码必须包含大小写字母和数字',
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请输入新密码"
            />
          </Form.Item>

          <Form.Item
            label="确认新密码"
            name="confirm_password"
            dependencies={['new_password']}
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请再次输入新密码"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              修改密码
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Settings;
